<template>
  <BaseCard>
    <BaseCardGroup>
      <BaseBox display="flex" align-items="center" justify-content="between">
        <h2 class="doctors-modal-title">Escolha o profissional</h2>
        <BaseIcon icon="cross" size="xs" @click="hideModal" />
      </BaseBox>
    </BaseCardGroup>

    <BaseCardGroup>
      <div class="doctors-modal-group">
        <div class="doctors-modal-group-item">
          <span class="doctors-modal-label">Unidade</span>
          <h6 class="doctors-modal-subtitle">
            {{ selectedUnit.name }}
          </h6>
        </div>

        <div class="doctors-modal-group-item">
          <span class="doctors-modal-label">Especialidade médica</span>
          <h6 class="doctors-modal-subtitle">
            {{ selectedSpecialty.name }}
          </h6>
        </div>
      </div>
    </BaseCardGroup>

    <BaseCardBody>
      <template v-if="loading">
        <BaseBox display="flex" align-items="center" justify-content="center">
          <BaseSpinner class="mt-5 mb-5" />
        </BaseBox>
      </template>
      <template v-else>
        <div v-if="institution_doctors.length" class="doctors-modal-cards">
          <BaseCard
            v-for="(doctor, index) in institution_doctors"
            :key="doctor.id + index"
            bordered
          >
            <BaseCardBody>
              <BaseBox display="flex" flex-direction="column" gap="md">
                <BaseBox
                  display="flex"
                  :flex-direction="{ '': 'column', sm: 'row' }"
                  :align-items="{ '': 'center', sm: 'start' }"
                  gap="md"
                >
                  <BaseAvatar
                    :src="doctor.photo"
                    :text="getInitials(doctor.name)"
                    size="md"
                  />
                  <div>
                    <h2 class="doctors-modal-doctor">
                      {{ doctor.name }}
                    </h2>
                    <span class="doctors-modal-description">
                      {{ doctor.doctor_property.medical_specialty_name }} -
                      {{ doctor.doctor_property.council_name }} -
                      {{ doctor.doctor_property.council_number }}
                    </span>
                  </div>
                </BaseBox>

                <BaseBox
                  display="flex"
                  align-items="center"
                  :flex-direction="{ '': 'column', sm: 'row' }"
                  gap="md"
                > 
                  <template v-if="institutionType !== 'public_institutions'">
                    <span class="doctors-modal-price">
                      {{ doctor.doctor_property.price }}
                    </span>
                  </template>
                  <BaseButton
                    variant="neutral"
                    pill
                    block
                    @click="chooseDoctor(doctor)"
                  >
                    Escolher
                  </BaseButton>
                </BaseBox>
              </BaseBox>
            </BaseCardBody>
          </BaseCard>
        </div>
        <EmptyState
          v-else
          title="Nenhum profissional encontrado!"
          text="Escolha outra especialidade ou unidade de atendimento"
        />
      </template>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { getNameInitials } from '../../utils/getNameInitials';
import EmptyState from '../EmptyState.vue';

export default {
  name: 'InstitutionDetailsModal',
  components: {
    EmptyState,
  },
  props: {
    unitId: {
      type: String,
      default: '',
    },
    specialtyId: {
      type: String,
      default: '',
    },
  },
  created() {
    this.getInstitutionDoctors();
  },
  methods: {
    ...mapActions('doctor', ['fetchInstitutionDoctors']),

    async getInstitutionDoctors() {
      const params = {
        medicalSpecialty: this.specialtyId,
        unitId: this.unitId,
      };
      await this.fetchInstitutionDoctors(params);
    },
    chooseDoctor(doctor) {
      this.$emit('chooseDoctor', doctor);
    },
    getInitials(name) {
      return getNameInitials(name);
    },
    hideModal() {
      this.$bvModal.hide('doctorsModal');
    },
  },
  computed: {
    ...mapGetters('doctor', ['institution_doctors', 'loading']),
    ...mapGetters('institutions', ['units', 'unitSpecialties']),

    selectedUnit() {
      let unitIdx = this.units.findIndex((unit) => unit.id == this.unitId);
      return this.units[unitIdx];
    },
    selectedSpecialty() {
      let specialtyIdx = this.unitSpecialties.findIndex(
        (specialty) => specialty.id == this.specialtyId,
      );
      return this.unitSpecialties[specialtyIdx];
    },
    institutionType() {
      return new URLSearchParams(window.location.search).get('institution_type')
    }
  },
};
</script>

<style>
#doctorsModal___BV_modal_content_ {
  border-radius: 0.5rem !important;
}
#doctorsModal___BV_modal_body_ {
  padding: 0 !important;
}
</style>
